import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import FavoritesContext from "../../contexts/favorites-course";

const TopNav = () => {
    const favoritesCtx = useContext(FavoritesContext);

    return (
        <nav>
            <div className="row">
                <div className="col-sm-6 col-xs-12">
                    <ul>
                        <li>
                            <NavLink
                                to="/"
                                exact
                                activeStyle={{ color: "lime" }}
                            >
                                {" "}
                                صفحه اصلی{" "}
                            </NavLink>
                            <NavLink
                                to="/favorite"
                                activeStyle={{ color: "lime" }}
                            >
                                علاقه مندی ها
                                <span
                                    style={{
                                        background: "black",
                                        color: "white", borderRadius: "12px", padding: ".5rem 1rem", marginRight: ".5rem"
                                    }}
                                >
                                    {favoritesCtx.totalFavorites}
                                </span>
                            </NavLink>
                            <a href=""> درباره ما </a>
                            <a href=""> تماس با ما </a>
                        </li>
                    </ul>
                </div>
                <div className="col-sm-6 col-xs-12">
                    <div className="clientarea">
                        <div className="signin ">
                            <i className="zmdi zmdi-account"></i>
                            <NavLink
                                to="/login"
                                activeStyle={{ color: "lime" }}
                            >
                                {" "}
                                ورود{" "}
                            </NavLink>{" "}
                            /
                            <NavLink
                                to="/register"
                                activeStyle={{ color: "lime" }}
                            >
                                {" "}
                                عضویت{" "}
                            </NavLink>


                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default TopNav;
